module.exports = __webpack_public_path__ + "static/img/REVIEW.bd373a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/REVIEW.png
// module id = YDKr
// module chunks = 18